import React, { Component } from "react";

import { unfollowUser } from "../../helper/follow_helper";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";
import FollowView from "./follow_view";

let strings = new LocalizedStrings({ en });
class FollowButton extends Component {
  state = { showFollowView: false };

  render() {
    var classname = "edit_logout";
    if (this.props.userlist === true) {
      classname = "align_element";
    }
    if (this.props.user.user_signed_in === false) {
      // We don't show any follow button if user is not sign in
      return <div />;
    }
    if (this.props.user.me === true) {
      // We don't show any follow button if the user is himself
      return <div />;
    }
    if (this.props.user.friend === true) {
      return (
        <div className={classname}>
          {this.renderFollowView()}
          <button
            className="btn btn_primary btn_yaystack mr-1 right"
            style={{ fontFamily: "DIN Pro Bold", borderRadius: "10px" }}
            onClick={this.handlerUnfollow}
          >
            {strings.unfollow}
          </button>
        </div>
      );
    }
    return (
      <div className={classname}>
        {this.renderFollowView()}
        <button
          className="btn btn_primary btn_yaystack mr-1 right"
          style={{ fontFamily: "DIN Pro Bold", borderRadius: "10px" }}
          onClick={this.handlerFollow}
        >
          {strings.follow}
        </button>
      </div>
    );
  }

  componentWillUnmount() {
    if (this.followUserCall) {
      this.followUserCall.cancel();
    }
    if (this.unfollowUserCall) {
      this.unfollowUserCall.cancel();
    }
  }

  renderFollowView() {
    if (this.state.showFollowView) {
      return (
        <FollowView
          user={this.props.user}
          handleAddFriend={this.props.handleAddFriend}
          handleCloseView={this.handleCloseView}
        />
      );
    }
    return <div />;
  }

  handleCloseView = event => {
    this.setState({ showFollowView: false });
  };

  handlerFollow = event => {
    event.preventDefault();
    this.setState({ showFollowView: true });
  };

  handlerUnfollow = event => {
    event.preventDefault();
    const self = this;
    this.unfollowUserCall = unfollowUser(this.props.user.username);
    this.unfollowUserCall.promise.then(answer => {
      self.props.handleRemoveFriend(answer.errors, self.props.user.username);
    });
  };
}

export default FollowButton;



// WEBPACK FOOTER //
// ./src/components/profile/follow_button.jsx